import { DestroyRef, inject } from '@angular/core';

export abstract class AbstractModalDialog {
  public hideSpinner: () => boolean;
  protected readonly destroyRef = inject(DestroyRef);
}
